import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "accessdate", label: "Огноо" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "orgcode", label: "Байгууллага" },
  { prop: "method", label: "Method" },
  { prop: "url_path", label: "URL" },
  { prop: "description", label: "Тайлбар" },
  { prop: "client_ip", label: "IP" },
  { prop: "result", label: "Үр дүн" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Мэдээллийн лог",
    endpoint: "/logs/info",
    columns: columns,
    show: { org: true, ip: true, method: true }
  }))
}
}

})